<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>资金费用管理</el-breadcrumb-item>
      <el-breadcrumb-item>资金费用明细</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions fund-rate-toolbar">
        <el-select v-model="query.symbol" placeholder="请选择合约" filterable clearable size="mini" class="toolbar-item">
          <el-option v-for="item in symbolList" :key="item.id" :label="item.symbol.toUpperCase()"
            :value="item.symbol" />
        </el-select>
        <el-date-picker v-model="dateRange" type="daterange" align="right" size="mini" unlink-panels range-separator="-"
          start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="timestamp"
          :picker-options="pickerOptions" class="toolbar-item toolbar-range" @change="onDateChange" />
        <el-input v-model="query.fundRateRecordId" placeholder="资金费用记录ID" clearable size="mini"
          class="toolbar-item toolbar-input-wide" @keyup.enter.native="search" />
        <el-input v-model="query.topUserId" placeholder="顶级用户ID(选填)" clearable size="mini"
          class="toolbar-item toolbar-input" @keyup.enter.native="search" />
        <el-select v-model="query.type" placeholder="用户范围" size="mini" class="toolbar-item toolbar-user-range">
          <el-option label="隐藏（仅普通用户）" :value="1" />
          <el-option label="显示（普通+模拟+特殊）" :value="2" />
        </el-select>
        <el-button type="primary" size="mini" @click="search">查询</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
        <el-button size="mini" @click="exportExcel">导出Excel</el-button>
      </div>
      <el-table :data="tableData" height="calc(100vh - 380px)" size="mini" border>
        <el-table-column type="index" width="50" label="序号" />
        <el-table-column prop="symbol" label="合约名">
          <template slot-scope="scope">
            <span class="sym-upper">{{ scope.row.symbol }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="accountId" label="合约账户ID" />
        <el-table-column prop="userId" label="用户ID" />
        <el-table-column prop="userTypeName" label="用户类型" min-width="110" />
        <el-table-column prop="positionValue" label="仓位价值" />
        <el-table-column label="仓位类型" width="180">
          <template slot-scope="scope">
            <span>{{ positionTypeText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="fundRateRecordId" label="资金费用记录ID" />
        <el-table-column prop="cast" label="费用" />
        <el-table-column label="费率">
          <template slot-scope="scope">
            <span>{{ formatFundRatePercent(scope.row.fundingRate) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间">
          <template slot-scope="scope">
            {{ scope.row.updatedTime | moment }}
          </template>
        </el-table-column>
      </el-table>
      <pagination :size="paginations.size" :page="paginations.page" :total="total" @pageChanged="handlePageChanged" />
    </el-card>
  </div>
</template>

<script>
import moment from 'moment'
import Pagination from 'components/pagination'
import BigNumber from 'bignumber.js'
import api from '../FundRate/api'

export default {
  name: 'SimulationFundRateBill',
  components: { Pagination },
  data() {
    return {
      symbolList: [],
      tableData: [],
      total: 0,
      dateRange: [],
      query: {
        symbol: '',
        topUserId: '',
        fundRateRecordId: '',
        type: 1,
      },
      paginations: { page: 1, size: 10 },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  watch: {
    '$route.query': {
      handler(q) {
        if (!q) return
        if (q.symbol) {
          this.query.symbol = q.symbol
        }
        if (q.fundRateRecordId != null && q.fundRateRecordId !== '') {
          this.query.fundRateRecordId = String(q.fundRateRecordId)
        }
        this.paginations.page = 1
        this.$nextTick(() => {
          if (this.dateRange && this.dateRange.length === 2 && this.query.symbol) {
            this.fetchList()
          }
        })
      },
      deep: true,
    },
  },
  mounted() {
    this.initDateRange()
    const q = this.$route.query || {}
    if (q.symbol) {
      this.query.symbol = q.symbol
    }
    if (q.fundRateRecordId != null && q.fundRateRecordId !== '') {
      this.query.fundRateRecordId = String(q.fundRateRecordId)
    }
    this.loadSymbols().then(() => {
      if (this.query.symbol) {
        this.fetchList()
      }
    })
  },
  methods: {
    initDateRange() {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
      this.dateRange = [start.getTime(), moment(end).endOf('day').valueOf()]
    },
    onDateChange(val) {
      if (!val || val.length !== 2) {
        this.dateRange = []
      }
    },
    timeParams() {
      if (!this.dateRange || this.dateRange.length !== 2) {
        return { startTime: null, endTime: null }
      }
      return {
        startTime: this.dateRange[0],
        endTime: moment(this.dateRange[1]).endOf('day').valueOf(),
      }
    },
    formatFundRatePercent(rate) {
      if (rate == null || rate === '') return '-'
      return `${new BigNumber(rate).times(100).toNumber().toFixed(6)}%`
    },
    positionTypeText(row) {
      const side =
        row.positionSide === 1 ? '多' : row.positionSide === 2 ? '空' : ''
      const t = row.positionType
      let base = '-'
      if (t === 0) base = '单向持仓'
      else if (t === 1) base = '全仓'
      else if (t === 2) base = '逐仓'
      else if (t != null) base = String(t)
      if (t === 0 && side) {
        return `${base}(${side})`
      }
      if ((t === 1 || t === 2) && side) {
        return `${base}(${side})`
      }
      return base
    },
    loadSymbols() {
      return api.getSymbolList().then((res) => {
        if (res.code === 0 && res.data) {
          this.symbolList = res.data
        }
      })
    },
    buildRequestParams() {
      const { startTime, endTime } = this.timeParams()
      const params = {
        page: this.paginations.page,
        size: this.paginations.size,
        symbol: this.query.symbol,
        type: this.query.type,
        startTime,
        endTime,
      }
      if (this.query.topUserId) {
        params.topUserId = this.query.topUserId
      }
      // if (this.query.fundRateRecordId) {
      //   const n = Number(String(this.query.fundRateRecordId).trim())
      //   if (!Number.isNaN(n)) {
      //     params.fundRateRecordId = n
      //   }
      // }
      params.fundRateRecordId = this.query.fundRateRecordId
      return params
    },
    fetchList() {
      const { startTime, endTime } = this.timeParams()
      if (startTime == null || endTime == null) {
        this.$message.warning('请选择时间范围')
        return
      }
      if (!this.query.symbol) {
        return
      }
      api.getFundDetailList(this.buildRequestParams()).then((res) => {
        if (res.code === 0 && res.data) {
          this.tableData = res.data.items || []
          this.total = Number(res.data.total || 0)
        }
      })
    },
    search() {
      if (!this.query.symbol) {
        this.$message.warning('请选择合约')
        return
      }
      this.paginations.page = 1
      this.fetchList()
    },
    exportExcel() {
      const { startTime, endTime } = this.timeParams()
      if (startTime == null || endTime == null) {
        this.$message.warning('请选择时间范围')
        return
      }
      if (!this.query.symbol) {
        this.$message.warning('请选择合约')
        return
      }
      api.exportFundDetailList(this.buildRequestParams()).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.download = '资金费用明细'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(link.href)
      })
    },
    reset() {
      this.query = { symbol: '', topUserId: '', fundRateRecordId: '', type: 1 }
      this.paginations = { page: 1, size: 10 }
      this.initDateRange()
      this.tableData = []
      this.total = 0
    },
    handlePageChanged(p) {
      this.paginations = { page: p.page, size: p.size }
      this.fetchList()
    },
  },
}
</script>

<style lang="less" scoped>
.fund-rate-toolbar {
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
}

.toolbar-item {
  margin-right: 8px;
}

.toolbar-range {
  width: 260px;
}

.toolbar-input {
  width: 150px;
}

.toolbar-input-wide {
  width: 190px;
}

.toolbar-user-range {
  width: 180px;
}

.sym-upper {
  text-transform: uppercase;
}
</style>
